import loadable from "@loadable/component";

const LoadableMarkdown = loadable(
  () =>
    import(/* webpackChunkName: "MarkdownComponent" */ "./MarkdownComponent"),
  { fallback: null }
);

export default LoadableMarkdown;
